import { useTranslation } from "react-i18next";
import { css } from "../../../../../../styled-system/css";
import { Box } from "../../../../../../styled-system/jsx";
import { Checkbox } from "../../../../fields/base/Checkbox";
import { StorePageSelector } from "./StorePageSelector";

interface SDStoreLandingPageSelectorProps {
  brandEntityId?: string;
  categoryId?: number;
  store: string | null;
  page: string | null;
  hasRequiredCreatives: boolean;
  customSdStorePageEnabled: boolean;
  onChange: (updates: Record<string, unknown>) => void;
  disableFields?: boolean;
  errors?: {
    customSdStorePageEnabled?: string;
    store?: string;
    page?: string;
  };
}

export function SDStoreLandingPageSelector({
  brandEntityId,
  categoryId,
  store,
  page,
  hasRequiredCreatives,
  customSdStorePageEnabled,
  onChange,
  disableFields = false,
  errors,
}: SDStoreLandingPageSelectorProps) {
  const { t } = useTranslation(["advertising"]);
  return (
    <Box className={css({ marginTop: "medium", paddingBottom: "xxlarge" })}>
      <Checkbox
        label={t(($) => $.advertising["Customize store landing page"])}
        isDisabled={disableFields || !hasRequiredCreatives}
        value={customSdStorePageEnabled}
        onChange={(checked) => {
          if (checked) {
            onChange({ customSdStorePageEnabled: true });
          } else {
            onChange({ customSdStorePageEnabled: false, store: null, page: null });
          }
        }}
      />
      {errors?.customSdStorePageEnabled && (
        <p className={css({ color: "error", fontSize: "small", paddingY: "medium" })}>
          {errors.customSdStorePageEnabled}
        </p>
      )}
      {!hasRequiredCreatives && (
        <p
          className={css({
            fontSize: "xsmall",
            color: "gray.500",
            marginTop: "xsmall",
          })}
        >
          {t(
            ($) =>
              $.advertising[
                "A brand logo, headline, and either a lifestyle image or video are required to customize the store page."
              ],
          )}
        </p>
      )}
      {customSdStorePageEnabled && hasRequiredCreatives && (
        <Box className={css({ marginTop: "small" })}>
          <StorePageSelector
            brandEntityId={brandEntityId}
            categoryId={categoryId}
            storeId={store}
            pageUrl={page}
            onStoreChange={(storeId) => onChange({ store: storeId })}
            onPageChange={(pageUrl) => onChange({ page: pageUrl })}
            disableFields={disableFields}
            storeErrorMessage={errors?.store}
            pageErrorMessage={errors?.page}
          />
        </Box>
      )}
    </Box>
  );
}
